module.exports = __webpack_public_path__ + "img/0025.24420029.jpg";